/**
 * 文件说明:
 *
 * request utils
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import _ from 'lodash'
import {router} from 'umi'
import {request as hzRequest} from '@huzan/hz-utils'
import {notification} from 'antd'
import {getState, dispatch} from './dva'

let loginErrorShow = false

const defaultNotShowErrorMessageMap = {
    'Failed to fetch': true,
    'NetworkError when attempting to fetch resource': true,
}

export function errorShow(options, error) {
    if (options.errorShow && !loginErrorShow) {
        const {message, description} = options.setErrorShowText(error)
        const notShowErrorMessageMap =
            options.notShowErrorMessageMap || defaultNotShowErrorMessageMap
        if (!notShowErrorMessageMap?.[description]) {
            loginErrorShow = true
            notification.error({
                message,
                description,
                onClose: () => {
                    loginErrorShow = false
                },
            })
        }
    }
}

let isResErrorShow = false

function resErrorShow({options, res, resErrorMessage}) {
    if (options.resErrorShow && !isResErrorShow) {
        isResErrorShow = true
        const {message, description} = options.setResErrorShowText({options, res, resErrorMessage})
        notification.error({
            message,
            description,
            onClose: () => {
                isResErrorShow = false
            },
        })
    }
}

function defaultSetResErrorShowText({resErrorMessage}) {
    return {message: `error:`, description: resErrorMessage}
}

function defaultSetResErrorMessage({options, res = {}}) {
    if (res.meta && res.meta.message) {
        return res.meta.message
    }

    return options.defaultResErrorText
}

function defaultRequestErrorHandle(error, options) {
    const status = _.get(error, 'response.status')

    if (status === 401) {
        dispatch({
            type: 'auth/logout',
            payload: {
                error,
            },
        })
        // errorShow(options, error)
    } else if (status === 403) {
        router.push('/403')
    } else {
        errorShow(options, error)
    }
}

function defaultOnBeforeFetch(newFetchOptions) {
    newFetchOptions.headers = {
        ...newFetchOptions.headers,
        Authorization: `Bearer ${_.get(getState(), 'base.accessToken')}`,
    }

    return newFetchOptions
}

export default async function request(url, fetchOptions = {}, options = {}) {
    options.onBeforeFetch = options.onBeforeFetch || defaultOnBeforeFetch
    options.requestErrorHandle = options.requestErrorHandle || defaultRequestErrorHandle

    const res = await hzRequest(url, fetchOptions, options)
    if (options.returnResponse) {
        return res
    }

    if (!res.meta) {
        return res
    }

    options.resErrorShow = typeof options.resErrorShow === 'undefined' || options.resErrorShow
    options.setResErrorShowText = options.setResErrorShowText || defaultSetResErrorShowText
    options.setResErrorMessage = options.setResErrorMessage || defaultSetResErrorMessage
    options.defaultResErrorText = options.defaultResErrorText || 'some error!'
    options.checkMetaCode = options?.checkMetaCode ?? true

    if (options.checkMetaCode && _.get(res, 'meta.code') !== 200) {
        const resErrorMessage = options.setResErrorMessage({options, res})

        resErrorShow({options, res, resErrorMessage})

        const error = new Error(resErrorMessage)
        error.HzReqRes = res

        throw error
    }

    return res
}
